import React from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';

const SetCardQuestion = props => {
  return (
    <div style={{marginLeft: '10px'}}>
      <RaisedButton
        label='Спросить'
      />
    </div>
  );
}

export default connect()(SetCardQuestion);



// WEBPACK FOOTER //
// ./src/components/layout/content/catalog/set/card/card-zones/question.js